<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            رسوم المرضى / المترددين
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            آليات الرسوم والإعفاء وأثرها على وصول الخدمات
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-finance')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">62%</div>
          <div class="kpi-label">أسر تتحمل كامل التكلفة</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">25%</div>
          <div class="kpi-label">تستفيد من إعفاء جزئي</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card success">
          <div class="kpi-value">13%</div>
          <div class="kpi-label">إعفاء كامل</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">6/9</div>
          <div class="kpi-label">مرافق بدون آلية إعفاء</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">سياسة الرسوم والإعفاء</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>هل توجد رسوم؟</th>
            <th>متوسط الرسوم/زيارة</th>
            <th>نظام الإعفاء</th>
            <th>معايير الإعفاء</th>
            <th>نسبة المعفيين%</th>
            <th>تأثير الرسوم على الوصول</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>{{ item.hasFees }}</td>
            <td>{{ item.averageFees }}</td>
            <td>
              <v-chip
                v-if="item.exemptionSystem !== 'N/A'"
                :color="chipColor(item.exemptionSystem)"
                size="small"
                variant="flat"
                >{{ item.exemptionSystem }}</v-chip
              >
              <span v-else>N/A</span>
            </td>
            <td>{{ item.exemptionCriteria }}</td>
            <td class="font-weight-bold">{{ item.exemptedRate }}</td>
            <td>
              <v-chip
                v-if="item.accessImpact !== 'N/A'"
                :color="impactColor(item.accessImpact)"
                size="small"
                variant="flat"
                >{{ item.accessImpact }}</v-chip
              >
              <span v-else>N/A</span>
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    hasFees: "نعم",
    averageFees: "2,000-5,000 ريال",
    exemptionSystem: "جزئي",
    exemptionCriteria: "حالات طوارئ فقط",
    exemptedRate: "10%",
    accessImpact: "شديد",
  },
  {
    name: "مستشفى الأمراض النفسية",
    hasFees: "رمزية",
    averageFees: "500-1,000 ريال",
    exemptionSystem: "لا يوجد",
    exemptionCriteria: "—",
    exemptedRate: "0%",
    accessImpact: "متوسط",
  },
  {
    name: "مجمع الشيخ عثمان",
    hasFees: "نعم",
    averageFees: "1,000-3,000 ريال",
    exemptionSystem: "جزئي",
    exemptionCriteria: "الفقر المدقع",
    exemptedRate: "15%",
    accessImpact: "متوسط",
  },
  {
    name: "مركز كود العثماني",
    hasFees: "نعم",
    averageFees: "500-2,000 ريال",
    exemptionSystem: "جزئي",
    exemptionCriteria: "الطوارئ + الفقر",
    exemptedRate: "20%",
    accessImpact: "خفيف",
  },
  {
    name: "مركز الممدارة",
    hasFees: "نعم",
    averageFees: "500-1,500 ريال",
    exemptionSystem: "كامل",
    exemptionCriteria: "سياسة واضحة",
    exemptedRate: "25%",
    accessImpact: "خفيف",
  },
  {
    name: "مركز المحاريق",
    hasFees: "نعم",
    averageFees: "1,000-2,500 ريال",
    exemptionSystem: "لا يوجد",
    exemptionCriteria: "—",
    exemptedRate: "0%",
    accessImpact: "شديد",
  },
  {
    name: "مركز عبد القوي",
    hasFees: "نعم",
    averageFees: "500-1,500 ريال",
    exemptionSystem: "جزئي",
    exemptionCriteria: "الطوارئ",
    exemptedRate: "18%",
    accessImpact: "خفيف",
  },
  {
    name: "مركز ماري ستبوس",
    hasFees: "مجاني",
    averageFees: "0",
    exemptionSystem: "N/A",
    exemptionCriteria: "—",
    exemptedRate: "100%",
    accessImpact: "N/A",
  },
  {
    name: "جمعية حقوق الطفل",
    hasFees: "مجاني",
    averageFees: "0",
    exemptionSystem: "N/A",
    exemptionCriteria: "—",
    exemptedRate: "100%",
    accessImpact: "N/A",
  },
];

const chipColor = (value) => {
  if (value === "كامل") return "green";
  if (value === "جزئي") return "orange";
  return "red";
};

const impactColor = (value) => {
  if (value === "خفيف") return "green";
  if (value === "متوسط") return "orange";
  return "red";
};

const showView = (view) => console.log("Go to:", view);
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.success {
  background: #e8f5ee;
  color: #1a7a4a;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
